import { render, staticRenderFns } from "./zhuanbox.vue?vue&type=template&id=211ac4ba&scoped=true&"
import script from "./zhuanbox.vue?vue&type=script&lang=js&"
export * from "./zhuanbox.vue?vue&type=script&lang=js&"
import style0 from "./zhuanbox.vue?vue&type=style&index=0&id=211ac4ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211ac4ba",
  null
  
)

export default component.exports